
const ENV = process.env.NODE_ENV
export default {
  DOMAIN: 'http://127.0.0.1:8080',
  // baseURL: ENV == 'development'?'http://127.0.0.1:8080':'127.0.0.1:8080',
  // baseURL: "http://login.jianyanedu.cn",
  // imageURL: "http://login.jianyanedu.cn",
  baseURL: "https://login.jianyanedu.cn",
  imageURL: "https://login.jianyanedu.cn",
  util: {
    image: '/util/image.html' // 图片上传
  }
}



// WEBPACK FOOTER //
// ./src/api/api.url.js